const nameReducer = (state = 'Ariean', action) => {
  switch (action.type) {
    case 'CHANGE_NAME_STATUS': {
      return action.payload
    }
    default:
      return state
  }
}
export default nameReducer